import React  from "react";
import Accordion from "../../components/Accordion";
import { Title, Wrapper } from "../../GlobalStyle";
import { FaqsWrapper } from "./Styled";

const FAQ_LIST = [
  {
    question: "Why SEEDverse?",
    answer: (
      <>
        <strong>Legal</strong>
        <p>
          SEEDverse will partner SEED Ventures, an MAS-licensed Venture Capital
          (VC) fund manager and Smaths Corporate Services, an ACRA registered
          Corporate Services Provider (CSP).
        </p>
        <strong>Turn-key Solution</strong>
        <p>Sister-companies = lower costs + higher speed-to-market. </p>
        <strong>Established brand</strong>
        <p>
          Wholesome reputation. Thousands of SME clients since 2010; >200 live
          SME companies at any point; green-lanes to investors/funds etc.
        </p>
      </>
    ),
  },
  {
    question: "Why the adoption of nfts going forward?",
    answer: (
      <>
        <strong>Thought leadership</strong>
        <p>
          First-to-market within the respective industry. Market Leader +
          Branding.
        </p>
        <strong>Collectible digital art </strong>
        <p>
          Cool artwork, gifs, or even motion graphics. It can be traded with
          royalties involved for the creator/principle. Helps to build a
          stronger consumer association with the company.
        </p>
        <strong>Fund-raise</strong>
        <p>
          A Fundraising campaign without losing equity. The ability to secure
          revenue upfront. Sales are NOT considered "unearned income".
        </p>
        <strong>Building Customer loyalty</strong>
        <p>
          NFT holders (customers) are the 'mouthpiece' to driving revenue and
          demand. Critical mass of adoption = sales. Helps to build a stronger
          bond with your loyal database of customers over time.
        </p>
      </>
    ),
  },
  {
    question: "Why is it worth it for your loyal customers?",
    answer: (
      <>
        <ul>
          <li>
            Might take only 2-3+ years to breakeven the cost of NFT purchase.
          </li>
          <li>
            Long-term brand association with your company - the 'feel good cool
            factor'.
          </li>
          <li>Potentially Revenue Share Option.</li>
          <li>
            Exclusive access to real-world privileges and perks to ONLY the NFT
            holders.
          </li>
        </ul>
      </>
    ),
  },
];

function Faqs() {
  return (
    <FaqsWrapper id="faqs">
      <Wrapper>
        <Title>FAQs</Title>
        <div className="faqs-container">
          {FAQ_LIST.map((faq, index) => (
            <Accordion key={index} content={faq} />
          ))}
        </div>
      </Wrapper>
    </FaqsWrapper>
  );
}
export default Faqs;
